import type { ReactNode } from 'react'
import { Inbox } from 'lucide-react'

type EmptyStateProps = {
  title: string
  description?: string
  action?: ReactNode
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-6 py-16 text-center">
      <div className="mb-1 flex h-10 w-10 items-center justify-center rounded-[var(--radius-md)] bg-slate-100 text-slate-400">
        <Inbox className="h-5 w-5" />
      </div>
      <h3 className="text-sm font-semibold text-[var(--color-text)]">{title}</h3>
      {description ? (
        <p className="max-w-sm text-xs text-[var(--color-text-muted)]">{description}</p>
      ) : null}
      {action ? <div className="mt-3">{action}</div> : null}
    </div>
  )
}
